import React from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Login from '../authentication/Login';
import history from './history';
import ForgetPassword from '../authentication/ForgetPassword';
import ResetPassword from '../authentication/ResetPassword';
import SidebarWrapper from '../layout/SidebarWrapper';
import SetPassword from '../pages/user/setPassword';
import VerifyEmail from '../pages/profile/verifyEmail';
import PaymentIntegration from '../pages/payment/integration';
import PaymentLinkExpired from '../utils/errorPages/PaymentLinkExpired';
import PaymentCancel from '../utils/errorPages/PaymentCancel';
import PaymentSuccess from '../utils/errorPages/PaymentSuccess';
import PaymentFailed from '../utils/errorPages/PaymentFailed';
import { isAuthenticated } from '../utils/AuthConfig';

function PrivateRoute() {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
}

const today = new Date();
const year = today.getFullYear();

function AppRoutes() {
  return (
    <BrowserRouter history={history}>
      <Routes>
        <Route exact path="/" element={<Login year={year} />} />
        <Route exact path="/forget-password" element={<ForgetPassword year={year} />} />
        <Route exact path="/reset-password/:code/:key" element={<ResetPassword year={year} />} />
        <Route exact path="/set-password/:code/:key" element={<SetPassword year={year} />} />
        <Route path="/payment/:code/:token" element={<PaymentIntegration />} />
        <Route path="/payment-link-exprie" element={<PaymentLinkExpired />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/payment/success/:code" element={<PaymentSuccess />} />
        <Route path="/payment/fail" element={<PaymentFailed />} />
        <Route exact path="/verify-email/:code" element={<VerifyEmail />} />
        <Route exact path="/link-expired" element={<PaymentLinkExpired />} />
        <Route exact path="/" element={<PrivateRoute />}>
          <Route exact path="/*" element={<SidebarWrapper />} />
        </Route>
        {/* <Route path="/404" exact={true} element={<NotFoundComponent />} />
        <Route path="/unauthorized" exact={true} element={<Unauthorized />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
